<template>
    <div v-if="value" class="register-dialog">
        <div class="register-body">
            <i class="el-icon-close" @click="$emit('input', false)"></i>
            <div class="reg-title f-22">手机注册</div>
            <div class="reg-sub f-14">電話番号で登録する</div>
            <el-input class="login-input" placeholder="请输入手机号" v-model="resForm.account" type="text" prefix-icon="el-icon-mobile-phone">
                <el-select class="input-with-select"
                           v-model="resForm.identifiers"
                           filterable
                           slot="append"
                           placeholder="请选择">
                    <el-option v-for="(item,index) in identifierList"
                               :key="index"
                               :label="item.country"
                               :value="item.mobile_prefix">
                    </el-option>
                </el-select>
            </el-input>
            <el-input class="login-input" placeholder="请输入验证码" v-model="resForm.code" type="text" prefix-icon="el-icon-key">
                <el-button v-if="time>=60" slot="append" @click="sendCode">获取验证码</el-button>
                <el-button v-else slot="append" @click="sendCode">{{time}}s后可重发</el-button>
            </el-input>
            <el-input class="login-input"
                      placeholder="请输入密码"
                      v-model="resForm.password"
                      type="password"
                      prefix-icon="el-icon-lock"></el-input>
            <el-input class="login-input"
                      placeholder="请确认密码"
                      type="password"
                      v-model="password"
                      prefix-icon="el-icon-lock"></el-input>
            <div class="btn-content cur-p bc-color-red color-fff" v-if="checked" @click="handlerRegister">完成注册</div>
            <div class="btn-content cur-p bc-color-gray color-fff" v-else>完成注册</div>
            <div class="login-bottom">已有账号？<span class="color-red cur-p" @click="toLogin">前往登录</span></div>
            <div class="forget-psd">
                <el-checkbox class="el-checkbox" v-model="checked">
                    <span style="font-size: 12px">注册即表示同意《东瀛民宿所有规则》</span>
                </el-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RegisterDialog",
        props:{
            value:{
                type: Boolean,
                default: false
            },
            identifierList: {
                type: Array,
                default(){
                    return []
                }
            }
        },
        data(){
            return{
                checked: false,
                password: '',
                resForm:{
                    identifiers: '86',
                    account: '',
                    password: '',
                    code: '',
                    mark: 0
                },
                timer: null,
                time: 60
            }
        },
        beforeDestroy(){
            clearInterval(this.timer)
        },
        methods:{
            async sendCode(){
                if(!this.resForm.account){
                    return this.$message.warning('请输入手机号')
                }
                let [e, data] = await this.$api.sendCodeApi({
                    identifiers: this.resForm.identifiers,
                    account: this.resForm.account,
                    mark: 0
                })
                if(e) return;
                if(data.code === 200){
                    this.time--;
                    this.timer = setInterval(()=>{
                        if(this.time>0){
                            this.time--;
                        }else {
                            clearInterval(this.timer)
                            this.time = 60;
                        }
                    }, 1000)
                }else {
                    this.$message.warning(data.msg)
                }
            },

            async handlerRegister(){
                if(!this.resForm.account){
                    return this.$message.warning('请输入手机号')
                }
                if(!this.resForm.code){
                    return this.$message.warning('请输入验证码')
                }
                if(!this.resForm.password){
                    return this.$message.warning('请输入密码')
                }
                if(!this.resForm.password){
                    return this.$message.warning('两次密码不一致')
                }
                let [e,data] = await this.$api.registerApi(this.resForm)
                if(e) return;
                if(data.code === 200){
                    this.$message.success('注册成功');
                    this.$emit('input', false)
                    this.$emit('openLogin')
                }else {
                    this.$message.warning(data.msg)
                }
            },
            toLogin(){
                this.$emit('input', false)
                this.$emit('openLogin')
            }
        }
    }
</script>

<style scoped lang="less">
    .register-dialog{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        .register-body{
            position: relative;
            width: 470px;
            height: 630px;
            border-radius: 8px;
            background-color: #ffffff;
            padding: 55px 60px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-flow: column;
            .el-icon-close{
                position: absolute;
                top: 20px;
                right: 20px;
                z-index: 10;
                font-size: 30px;
                cursor: pointer;
                color: #949494;
            }
            .reg-title{
                margin-bottom: 6px;
            }
            .reg-sub{
                color: #949494;
            }
        }
    }
    .login-input{
        margin-top: 30px;
        width: 82%;
        transform: scale(1.2);
    }
    .input-with-select{
        width: 112px;
    }
    .btn-content{
        width: 100%;
        height: 48px;
        line-height: 48px;
        margin-top: 30px;
        border-radius: 8px;
        user-select: none;
        text-align: center;
    }
    .login-bottom{
        width: 100%;
        margin-top: 20px;
        text-align: left;
        font-size: 14px;
    }
    .forget-psd{
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-size: 14px;
        .el-checkbox{
            transform-origin: 0 50%;
            transform: scale(1.2);
        }
        .forget-psd-btn{
            cursor: pointer;
            &:hover{
                color: #e44646;
            }
        }
    }
</style>
